import { queryOptions, useQuery } from "@tanstack/react-query";

import { getAuthzContext } from "../../api";

const authzContextQueryOptions = {
  all: () => ["authz-context"] as const,
  current: () =>
    queryOptions({
      queryKey: [...authzContextQueryOptions.all(), "current"] as const,
      queryFn: ({ signal }) => getAuthzContext(signal),
      staleTime: Infinity,
    }),
};

interface UseAuthzContextOptions {
  enabled: boolean;
}

function useAuthzContext({ enabled }: UseAuthzContextOptions) {
  return useQuery({ ...authzContextQueryOptions.current(), enabled });
}

export { authzContextQueryOptions, useAuthzContext };
